export enum EAccountsEventbusKey {
  POPUP_CRM_RECEIVED = 'POPUP_CRM_RECEIVED'
}
